module.exports = __webpack_public_path__ + "img/vertical-orientation-icon.b63bd42.svg";